import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var WifiIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M-.06.07h24v24h-24Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "5.5",
    cy: "18.51",
    r: "1.55"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.94,10.11v3.64a7.25,7.25,0,0,1,6.31,6.32H13.9A10.89,10.89,0,0,0,3.94,10.11Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.94,4.07V7.79A12.31,12.31,0,0,1,16.22,20.07h3.72A16,16,0,0,0,3.94,4.07Z"
  })]
}), 'WifiIcon');